import { Link } from 'react-router';
import { cn } from '@/lib/cn';

type LogoProps = { to?: string; wordmark?: boolean; size?: 'sm' | 'md'; label?: string; className?: string };

/** 28px ink square with `>_` + "devlearn" wordmark. */
export function Logo({ to = '/', wordmark = true, size = 'md', label, className }: LogoProps) {
  return (
    <Link
      to={to}
      aria-label={label ?? (wordmark ? undefined : 'devlearn home')}
      className={cn('flex items-center gap-2.5 text-ink no-underline hover:text-ink', className)}
    >
      <span
        aria-hidden="true"
        className={cn(
          'flex items-center justify-center rounded-md bg-ink font-mono font-medium text-canvas',
          size === 'sm' ? 'size-[26px] text-xs' : 'size-7 text-sm',
        )}
      >
        &gt;_
      </span>
      {wordmark && (
        <span
          className={cn('font-display font-bold tracking-[-0.01em]', size === 'sm' ? 'text-lg' : 'text-xl')}
        >
          devlearn
        </span>
      )}
    </Link>
  );
}
